var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wvfl44fhia",
    d: "M0.055 0.145L8 0.145 8 8.536 0.055 8.536z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "M3.89 12.815h4.056c-.115-.364-.18-.752-.18-1.155s.065-.792.18-1.155H3.89l1.054-1.07c.445-.45.445-1.181 0-1.633-.445-.45-1.167-.45-1.612 0l-2.998 3.04c-.053.054-.1.114-.142.176-.02.03-.032.06-.05.091-.018.037-.04.07-.055.108-.016.04-.025.08-.036.12-.01.031-.022.063-.028.095-.03.15-.03.304 0 .454.006.033.018.064.028.096.01.04.02.08.036.12.016.037.037.072.056.107.017.03.03.063.049.091.042.063.089.122.142.176l2.998 3.04c.445.451 1.167.451 1.612 0 .445-.45.445-1.182 0-1.633L3.89 12.815zM15.304 18.307c-.445-.451-1.167-.451-1.61 0l-1.055 1.068v-4.112c-.359.117-.742.18-1.139.18-.398 0-.78-.063-1.14-.18v4.112l-1.053-1.068c-.445-.451-1.167-.451-1.612 0-.444.45-.444 1.183 0 1.634l3 3.04c.052.054.11.102.173.144.028.019.06.033.09.049.034.02.068.04.106.057.038.016.078.025.117.037.032.009.062.022.095.029.148.029.3.029.447 0 .033-.007.063-.02.095-.03.04-.011.08-.02.118-.036.037-.016.071-.037.106-.057.03-.016.061-.03.09-.05.062-.041.12-.09.173-.143l3-3.04c.444-.451.444-1.183 0-1.634",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(15 7.319)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lv9h9xd0cb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wvfl44fhia"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "M7.978 4.114c-.007-.033-.019-.064-.028-.097-.012-.039-.021-.08-.036-.119-.016-.038-.038-.072-.057-.108-.016-.03-.029-.061-.048-.09-.042-.064-.089-.123-.142-.176L4.668.483c-.445-.451-1.166-.451-1.611 0-.445.452-.445 1.183 0 1.634l1.054 1.068H.055c.115.365.178.752.178 1.155 0 .404-.063.791-.178 1.156h4.056L3.057 6.564c-.445.451-.445 1.182 0 1.633.445.452 1.166.452 1.611 0l2.999-3.04c.053-.053.1-.113.142-.176.019-.029.032-.06.048-.09.019-.036.041-.07.057-.109.015-.038.024-.079.036-.118.009-.033.021-.064.028-.097.03-.15.03-.304 0-.453",
    mask: "url(#lv9h9xd0cb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "M15.304 3.378L12.305.338c-.053-.054-.11-.102-.173-.144-.029-.019-.059-.033-.089-.049-.036-.02-.07-.041-.107-.057-.038-.016-.078-.025-.118-.037-.032-.01-.062-.022-.095-.029-.148-.029-.299-.029-.447 0-.033.007-.063.019-.095.029-.039.012-.079.021-.117.037-.038.016-.072.037-.108.057-.029.016-.06.03-.088.049-.063.042-.12.09-.174.144l-2.999 3.04c-.444.451-.444 1.183 0 1.634.445.451 1.167.451 1.612 0l1.053-1.069v4.112c.36-.116.742-.181 1.14-.181.397 0 .78.065 1.14.181V3.943l1.053 1.069c.444.451 1.166.451 1.611 0 .445-.451.445-1.183 0-1.634",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303BA6",
    d: "M14.14 11.66c0 1.477-1.182 2.676-2.64 2.676-1.458 0-2.64-1.199-2.64-2.677s1.182-2.676 2.64-2.676c1.458 0 2.64 1.198 2.64 2.676",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamal);
export default __webpack_public_path__ + "static/media/hamal.c2fd97fe2c3a64a4a2b4c9037739bf1a.svg";
export { ForwardRef as ReactComponent };